import { MarkerPropertiesInterface } from "modules/construction-work/src/Common/interface";
import { DEFAULT_COLOR } from "modules/construction-work/src/Common/const/MarkerConfigsConst";
import {
    Coordinate,
    LineString,
    Map,
    Marker,
    VectorLayer,
    OverlayLayer,
} from "maptalks";
import GeometryRendererAbstract from 'modules/construction-work/src/Entity/Map/GeometryRendererAbstract';

export default class LineRenderer extends GeometryRendererAbstract {
    render(geometry: LineString, markerLayer: VectorLayer, map: Map): void {
        const properties = (geometry as any).properties as MarkerPropertiesInterface;

        // рисуем линию
        const color = properties.settingsMarker?.fillColor || DEFAULT_COLOR;
        geometry.setSymbol(this.createLineSymbol(color, 2));
        geometry.addTo(map.getLayer('l') as OverlayLayer);

        // находим центр линии, который точно лежит на границе линии
        const midpoint = this.getLineMidpoint(geometry);

        // console.log(midpoint);
        // console.log(geometry.getCenter());
        // // console.log(properties);
        // console.log("------------");
        //
        // const debugMarker = new Marker(geometry.getCenter(), {
        //     symbol: {
        //         markerType: 'ellipse' as const,
        //         markerWidth: 10,
        //         markerHeight: 10,
        //         markerFill: '#ff0000',
        //         markerLineWidth: 0,
        //         zIndex: 999,
        //     },
        // });
        // markerLayer.addGeometry(debugMarker);

        let svgMap = properties.settingsMarker?.svgMap;

        if (!svgMap){
            svgMap = properties.settingsMarker?.imgMap;
        }

        if (svgMap) {
            const markerSymbols = this.buildMarkerSymbols(
                properties
            );

            const marker = new Marker(midpoint, {
                symbol: markerSymbols,
                properties,
            });
            markerLayer.addGeometry(marker);
        }


    }

    /**
     * Возвращает точку, лежащую на линии ровно посередине её длины
     */
    private getLineMidpoint(line: LineString): Coordinate {
        const coords = line.getCoordinates();

        if (coords.length < 2) {
            return coords[0];
        }

        let total = 0;
        const segments: number[] = [];

        for (let i = 1; i < coords.length; i++) {
            const d = coords[i - 1].distanceTo(coords[i]);
            segments.push(d);
            total += d;
        }

        const half = total / 2;
        let acc = 0;

        for (let i = 0; i < segments.length; i++) {
            if (acc + segments[i] >= half) {
                const ratio = (half - acc) / segments[i];

                const start = coords[i];
                const end = coords[i + 1];

                return new Coordinate(
                    start.x + (end.x - start.x) * ratio,
                    start.y + (end.y - start.y) * ratio
                );
            }
            acc += segments[i];
        }

        return coords[0];
    }
}
